import { selectorFamily } from "recoil";
import {
  ActiveEmailAtom,
  EditEmailAtom,
  IActiveEmailAtom,
  IEditEmailAtom,
  SentToContactEmailAtom,
} from "../atoms/ActiveEmailAtom";
import { TempCampaignAtom } from "../atoms/CampaignAtom";
import { ICampaignEmailAtom } from "./CampaignEmailAtom";

export type EmailMode =
  | "edit"
  | "campaign"
  | "new-email"
  | "opened"
  | "send-to-contact";
export type EmailSelectorFamilyParams = { mode: EmailMode; index?: number };
export type IEmailAtom = IActiveEmailAtom | IEditEmailAtom | ICampaignEmailAtom;

const EmailSelectorFamily = selectorFamily<
  IEmailAtom,
  EmailSelectorFamilyParams
>({
  key: "email",
  //@ts-ignore
  get:
    ({ mode, index }: EmailSelectorFamilyParams) =>
    ({ get }) => {
      switch (mode) {
        case "edit":
        case "opened":
          return get(EditEmailAtom);
        case "send-to-contact":
          return get(SentToContactEmailAtom);
        case "new-email":
          return get(ActiveEmailAtom);
        case "campaign": {
          const tempCampaign = get(TempCampaignAtom);
          const tempCampaignNode = tempCampaign.nodes[index].email;
          return tempCampaignNode;
        }
      }
    },
  set:
    ({ mode, index }: EmailSelectorFamilyParams) =>
    ({ set, get }, newValue) => {
      switch (mode) {
        case "edit":
        case "opened": {
          set(EditEmailAtom, newValue);
          break;
        }
        case "new-email": {
          set(ActiveEmailAtom, newValue);
          break;
        }
        case "send-to-contact":
          set(SentToContactEmailAtom, newValue);
          break;
        case "campaign": {
          const tempCampaign = get(TempCampaignAtom);
          const newBody = (newValue as any).body;

          set(TempCampaignAtom, {
            ...tempCampaign,
            nodes: [
              ...tempCampaign.nodes.slice(0, index),
              {
                ...tempCampaign.nodes[index],
                email: { ...newValue, body: newBody },
              },
              ...tempCampaign.nodes.slice(index + 1),
            ],
          });
        }
      }
    },
});

export default EmailSelectorFamily;
